module.exports = __webpack_public_path__ + "static/media/rastatech.ae67a7a2.jpg";